import React from "react";
import { Box, Radio, Typography } from "@mui/material";

interface MyHrLoginTwoFactorSelectTypeOptionsProps {
  value: string;
  checked: boolean;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
  label: React.ReactNode;
  description: React.ReactNode;
}

export const MyHrLoginTwoFactorSelectTypeOptions = ({
  value,
  checked,
  onChange,
  label,
  description,
}: MyHrLoginTwoFactorSelectTypeOptionsProps) => {
  return (
    <Box sx={{ textAlign: "left", marginBottom: "16px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Radio
          value={value}
          checked={checked}
          onChange={onChange}
          color="default"
          sx={{
            width: "20px",
            height: "20px",
            marginRight: "16px",
            color: "#919699",
          }}
        />
        <Typography variant="body1" sx={{ fontWeight: "700" }}>
          {label}
        </Typography>
      </Box>
      <Box height="8px" />
      <Typography variant="body1" sx={{ marginLeft: "36px" }}>
        {description}
      </Typography>
    </Box>
  );
};

export default MyHrLoginTwoFactorSelectTypeOptions;
